/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function HobbiesIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-hobbies">
        <g id="Group 65 Copy 2">
          <g id="Group 63 Copy 2">
            <g id="Group 61 Copy 2">
              <g id="Group 59 Copy 3">
                <g id="icon-legal and finance copy">
                  <g id="Group 58 Copy 2">
                    <g id="icon-journey-course">
                      <circle
                        id="Oval"
                        cx="78.5"
                        cy="78.5"
                        r="77.5"
                        fill={mainColor}
                        stroke="white"
                        stroke-width="2"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="puzzle-piece-plugin copy">
          <path
            id="Path"
            d="M117.762 75.9524H111.619V59.5714C111.619 55.0667 107.933 51.381 103.429 51.381H87.0476V45.2381C87.0476 39.5048 82.5429 35 76.8095 35C71.0762 35 66.5714 39.5048 66.5714 45.2381V51.381H50.1905C45.6857 51.381 42 55.0667 42 59.5714V75.1333H48.1429C54.2857 75.1333 59.2 80.0476 59.2 86.1905C59.2 92.3333 54.2857 97.2476 48.1429 97.2476H42V112.81C42 117.314 45.6857 121 50.1905 121H65.7524V114.857C65.7524 108.714 70.6667 103.8 76.8095 103.8C82.9524 103.8 87.8667 108.714 87.8667 114.857V121H103.429C107.933 121 111.619 117.314 111.619 112.81V96.4286H117.762C123.495 96.4286 128 91.9238 128 86.1905C128 80.4571 123.495 75.9524 117.762 75.9524Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
}

HobbiesIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
HobbiesIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(HobbiesIcon);
memoized.displayName = 'HobbiesIcon';
export default memoized;
